import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export type NombreIcono =
  | 'inicio'
  | 'categorias'
  | 'novedades'
  | 'carrito'
  | 'cuenta'
  | 'buscar'
  | 'menu'
  | 'cerrar'
  | 'campana'
  | 'instalar'
  | 'clientes'
  | 'pedidos'
  | 'ciclo'
  | 'pagos'
  | 'red'
  | 'retiros'
  | 'puntos'
  | 'compartir'
  | 'entregas'
  | 'bodega'
  | 'lotes'
  | 'abonos'
  | 'compras'
  | 'catalogo'
  | 'tasas'
  | 'vendedores'
  | 'ajustes'
  | 'reportes'
  | 'salir'
  | 'derecha'
  | 'izquierda'
  | 'mas'
  | 'menos'
  | 'quitar'
  | 'copiar'
  | 'filtros'
  | 'whatsapp'
  | 'reloj'
  | 'regla'
  | 'check'
  | 'alerta'
  | 'ayuda'
  | 'externo';

// Íconos de trazo propios (sin librería externa: la CSP no admite fuentes remotas)
@Component({
  selector: 'app-icono',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'inline-flex shrink-0', 'aria-hidden': 'true' },
  template: `
    <svg viewBox="0 0 24 24" [attr.width]="tamano()" [attr.height]="tamano()" fill="none" stroke="currentColor"
      stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">
      @switch (nombre()) {
        @case ('inicio') { <path d="M4 10.5 12 4l8 6.5V20h-5.5v-6h-5v6H4v-9.5Z" /> }
        @case ('categorias') { <path d="M5 4h5v5H5zM14 4h5v5h-5zM5 15h5v5H5zM14 15h5v5h-5z" /> }
        @case ('novedades') { <path d="M12 3.5l2.3 5.2 5.7.5-4.3 3.8 1.3 5.5L12 15.6l-5 2.9 1.3-5.5L4 9.2l5.7-.5L12 3.5Z" /> }
        @case ('carrito') { <path d="M5.5 8h13l-1 12h-11l-1-12Z" /><path d="M9 8V6.5a3 3 0 0 1 6 0V8" /> }
        @case ('cuenta') { <circle cx="12" cy="8.5" r="3.8" /><path d="M4.5 20a7.5 7.5 0 0 1 15 0" /> }
        @case ('buscar') { <circle cx="11" cy="11" r="6.5" /><path d="m16 16 4 4" /> }
        @case ('menu') { <path d="M4 7h16M4 12h16M4 17h10" /> }
        @case ('cerrar') { <path d="M6 6l12 12M18 6 6 18" /> }
        @case ('instalar') { <path d="M12 4v11" /><path d="m7.5 10.5 4.5 4.5 4.5-4.5" /><path d="M5 19h14" /> }
        @case ('campana') { <path d="M6.5 16V11a5.5 5.5 0 0 1 11 0v5l1.5 2h-14l1.5-2Z" /><path d="M10 20.5a2 2 0 0 0 4 0" /> }
        @case ('clientes') { <circle cx="9" cy="8.5" r="3.3" /><path d="M3 19.5a6 6 0 0 1 12 0M15.5 5.2a3.3 3.3 0 0 1 0 6.6M18 14.5a6 6 0 0 1 3 5" /> }
        @case ('pedidos') { <path d="M6 3.5h12v17l-3-1.8-3 1.8-3-1.8-3 1.8v-17Z" /><path d="M9 8.5h6M9 12.5h6" /> }
        @case ('ciclo') { <path d="M19.5 12a7.5 7.5 0 1 1-2.2-5.3M19.5 4v4h-4" /> }
        @case ('pagos') { <rect x="3.5" y="6" width="17" height="12" rx="2" /><path d="M3.5 10h17M7 14.5h3" /> }
        @case ('red') { <circle cx="12" cy="5.5" r="2.3" /><circle cx="5.5" cy="18" r="2.3" /><circle cx="18.5" cy="18" r="2.3" /><path d="M11 7.5 6.5 16M13 7.5l4.5 8.5M8 18h8" /> }
        @case ('retiros') { <path d="M12 4v11M7.5 10.5 12 15l4.5-4.5M5 19.5h14" /> }
        @case ('puntos') { <path d="M12 3.5 14.4 8l5 .8-3.6 3.5.9 5-4.7-2.4-4.7 2.4.9-5L4.6 8.8l5-.8L12 3.5Z" /><path d="M9 21h6" /> }
        @case ('compartir') { <circle cx="17.5" cy="5.5" r="2.5" /><circle cx="6.5" cy="12" r="2.5" /><circle cx="17.5" cy="18.5" r="2.5" /><path d="m8.7 10.8 6.6-4M8.7 13.2l6.6 4" /> }
        @case ('entregas') { <path d="M3.5 7.5h10v9h-10zM13.5 10.5h4l3 3v3h-7" /><circle cx="7" cy="18" r="1.7" /><circle cx="17" cy="18" r="1.7" /> }
        @case ('bodega') { <path d="M3.5 9 12 4.5 20.5 9v10.5h-17V9Z" /><path d="M8 19.5v-6h8v6M8 16.5h8" /> }
        @case ('lotes') { <path d="M12 3.5 20 7.5v9L12 20.5 4 16.5v-9L12 3.5Z" /><path d="M4 7.5l8 4 8-4M12 11.5v9" /> }
        @case ('abonos') { <path d="M5 12.5l4.5 4.5L19 7.5" /><rect x="3" y="3.5" width="18" height="17" rx="3" /> }
        @case ('compras') { <path d="M3.5 4.5h2.5l2.2 10.5h10.3l2-7.5H7" /><circle cx="9.5" cy="19" r="1.4" /><circle cx="17" cy="19" r="1.4" /> }
        @case ('catalogo') { <path d="M8.5 4 12 6l3.5-2 5 3-2.5 3.5-1.5-1V20h-9V9.5l-1.5 1L3.5 7l5-3Z" /> }
        @case ('tasas') { <path d="M4 17l5-5 4 3 7-8M15 7h5v5" /> }
        @case ('vendedores') { <circle cx="12" cy="8" r="3.5" /><path d="M5 20a7 7 0 0 1 14 0" /><path d="m15.5 15.5 1.5 1.5 3-3" /> }
        @case ('ajustes') { <circle cx="12" cy="12" r="3" /><path d="M12 3v2.5M12 18.5V21M3 12h2.5M18.5 12H21M5.6 5.6l1.8 1.8M16.6 16.6l1.8 1.8M5.6 18.4l1.8-1.8M16.6 7.4l1.8-1.8" /> }
        @case ('reportes') { <path d="M5 20V10M10 20V4.5M15 20v-7M20 20V8" /> }
        @case ('salir') { <path d="M14 4.5H6.5v15H14M10.5 12h10M17 8.5l3.5 3.5-3.5 3.5" /> }
        @case ('derecha') { <path d="m9.5 6 6 6-6 6" /> }
        @case ('izquierda') { <path d="m14.5 6-6 6 6 6" /> }
        @case ('mas') { <path d="M12 5v14M5 12h14" /> }
        @case ('menos') { <path d="M5 12h14" /> }
        @case ('quitar') { <path d="M4.5 7h15M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10.5 11v5.5M13.5 11v5.5" /> }
        @case ('copiar') { <rect x="8.5" y="8.5" width="11" height="11" rx="2" /><path d="M15.5 8.5V6a1.5 1.5 0 0 0-1.5-1.5H6A1.5 1.5 0 0 0 4.5 6v8A1.5 1.5 0 0 0 6 15.5h2.5" /> }
        @case ('filtros') { <path d="M4 7h9M17 7h3M4 17h3M11 17h9" /><circle cx="15" cy="7" r="2" /><circle cx="9" cy="17" r="2" /> }
        @case ('whatsapp') { <path d="M4.5 19.5l1.2-3.8A7.8 7.8 0 1 1 8.6 18.6l-4.1.9Z" /><path d="M9.3 8.6c.3 2.9 2.4 5 5.3 5.6l1.1-1.3-1.8-.9-.8.8c-1-.4-1.8-1.2-2.2-2.2l.8-.8-.8-1.8-1.6.6Z" /> }
        @case ('reloj') { <circle cx="12" cy="12" r="8" /><path d="M12 7.5V12l3 2" /> }
        @case ('regla') { <path d="M3.5 15.5 15.5 3.5l5 5-12 12-5-5Z" /><path d="m7.5 11.5 2 2M10.5 8.5l2 2M13.5 5.5l2 2" /> }
        @case ('check') { <path d="m5 12.5 4.5 4.5L19 7.5" /> }
        @case ('ayuda') { <circle cx="12" cy="12" r="8.5" /><path d="M9.6 9.4a2.5 2.5 0 0 1 4.8.9c0 1.7-2.4 2.2-2.4 3.7M12 17h.01" /> }
        @case ('alerta') { <path d="M12 4 21 19.5H3L12 4Z" /><path d="M12 10v4M12 17h.01" /> }
        @case ('externo') { <path d="M14 4.5h5.5V10M19.5 4.5 11 13" /><path d="M17 14v5.5H4.5V7H10" /> }
      }
    </svg>
  `,
})
export class IconoComponent {
  readonly nombre = input.required<NombreIcono>();
  readonly tamano = input(24);
}
